/* eslint-disable jsx-a11y/control-has-associated-label */
import PropTypes from 'prop-types';

import TableHeader from '../TableHeader/TableHeader';
import tableStyles from '../../WeeklyReportTable.module.scss';
import RowDivider from '../RowDivider/RowDivider';

import styles from './TableSkeleton.module.scss';

/**
 * @typedef Props
 * @property {boolean} isInspector
 * @property {Date} initialDay
 * @property {import('../../hooks/useSort').SortType} sortType
 */

/** @param {Props} */
const TableSkeleton = ({ isInspector, initialDay }) => (
  <div style={{ background: '#fff' }}>
    <div className={tableStyles.container}>
      <div className={tableStyles['table-container']}>
        <table cellPadding={0} className={tableStyles.table}>
          <TableHeader extendedView initialDay={initialDay} isInspector={isInspector} isLoading />
          <tbody>
            <tr>
              <td className={styles.row} colSpan={8} style={{ height: 210 }} />
            </tr>
            <RowDivider />
            <tr>
              <td className={styles.row} colSpan={8} style={{ height: 140 }} />
            </tr>
            <RowDivider />
            <tr>
              <td className={styles.row} colSpan={8} style={{ height: 280 }} />
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default TableSkeleton;

TableSkeleton.propTypes = {
  isInspector: PropTypes.bool.isRequired,
  initialDay: PropTypes.instanceOf(Date).isRequired
};
